<section class="w-full">
    <div class="grid flex flex-grow justify-content-between align-items-center">
      <div class="flex-1">
        <split-header-section
          title="Relatório de Atendimento"
        ></split-header-section>
      </div>
      <div>
        <button pButton pRipple class="split-button-gray-1 mr-2 active" style="border-radius: 5px !important;">
          EXPORTAR PARA EXCEL
        </button>
      </div>
    </div>
    <div class="mt-3">
        <service-report-filter-menu [filterBySplit]="true" (filterEvent)="addFilterOptions($event)"></service-report-filter-menu>
    </div>
    <div class="grid mt-2">
        <div class="col">
          <div class="bg-white p-5 border-round-2xl box-shadow" style="min-height:431px;">
            <div class="header mb-5 flex justify-content-between">
              <div>
                <span class="title"> Agendamentos </span> <br />
                <span class="subtitle">Relacionado aos últimos 12 meses</span>
              </div>
              <div class="flex">
                <split-select-button (onOptionClick)="toogleAgendamentosBtn($event)" [options]="optionAgendamentosBtn"></split-select-button>
              </div>
            </div>
            <div class="w-full">
              <div class="flex mb-4">
                <div class="header_total flex flex-column align-items-start pr-3" style="color:#FF8321">
                   48 Total
                  <span class="subtitle">  <span style="color:#92562A;font-weight: bolder;">14</span> cancelamentos 
                  <span style="color:#FF8321;font-weight: bolder;">32</span> efetivos </span>
                </div>
              </div>
              <ng-template #tooltipTemplate let-fullData="fullData" let-activedText="activedText">
                <div *ngIf="fullData">
                  <p class="nowrap">
                    <span class="chart-legend">{{activedText.title}}</span>
                  </p>
                  <p class="nowrap">
                    <span class="pagos">{{fullData[activedText.index]?.pagos}}</span> <span> Pagos </span>
                  </p>
                  <p class="nowrap">
                    <span class="gratuitos">{{fullData[activedText.index]?.gratuitos}}</span> <span> Gratuitos </span>
                  </p>
                </div>
              </ng-template>
              <split-bar [disableCurrency]="true" [tooltipTemplate]="tooltipTemplate" [data]="agendamentosData" [columns]="agendamentosLabel" color="#FF8321" [fullData]="resultAgendamentoDiario"></split-bar>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-8 xl:col-4 " > 
            <div class="bg-white p-5 border-round-2xl box-shadow" style="min-height:431px;">
              <div class="header mb-3 flex justify-content-between">
                <div class="w-full">
                  <div class="flex  mb-4 justify-content-between">
                    <div>
                      <span class="title"> Consultas agendadas online </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-full">
                <div class="flex mb-5">
                  <div class="header_total flex flex-column align-items-start pr-3" style="color:#7A95DC">
                     16 agendamentos
                  </div>
                </div>
                <div class="mb-4">
                  <span class="subtitle-1"> Quando os pacientes agendaram: </span>
                </div>
                <div>
                  <split-progress-bar [value]="[36]" [colors]="['#7A95DC']" [bgColor]="'#4C5C86'"></split-progress-bar>
                </div>
                <div>
                  <div class="card-message mt-4 mb-4">
                      <span>56%</span>
                      <span>Fora do horário de funcionamento</span>
                  </div>
                  <div class="card-message mt-2" [style.border-color]="'#4C5C86'">
                    <span [style.color]="'#4C5C86'">56%</span>
                    <span >Fora do horário de funcionamento</span>
                </div>
                </div>
              </div>
            </div>
        </div>          
    </div>     
    <div class="grid mt-2">
        <div class="col">
          <div class="bg-white p-5 border-round-2xl box-shadow">
            <div class="header mb-5 flex justify-content-between">
              <div>
                <span class="title"> Tipos de agendamentos </span> <br />
                <span class="subtitle">Relacionado aos últimos 12 meses</span>
              </div>
              <div class="flex">
                <split-select-button (onOptionClick)="toogleTipoAgendamentosBtn($event)" [options]="optionAgendamentosBtn"></split-select-button>
              </div>
            </div>
            <div class="w-full">
              <div class="flex mb-4">
                <div class="header_total flex flex-column align-items-start pr-3" style="color:#7A95DC">
                   107 agendamentos pagos
                  <span class="subtitle">  <span style="color:#4C5C86;font-weight: bolder;">52</span> 
                  agendamentos gratuitos </span>
                </div>
              </div>
            
              <split-bar [disableCurrency]="true" [tooltipTemplate]="tooltipTemplate" [data]="tipoAgendamentosData" [columns]="tipoAgendamentosLabel" color="#7A95DC" [fullData]="resultAgendamentoDiario"></split-bar>
          
            </div>
          </div>
        </div>
        <div class="col-12 md:col-8 xl:col-4"> 
            <div class="bg-white p-5 border-round-2xl box-shadow">
              <div class="header mb-5 flex justify-content-between">
                <div class="w-full">
                  <div class="flex  mb-3 justify-content-between">
                    <div>
                      <span class="title"> Onde foram feitos </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card flex justify-content-center">
                <split-doughnut-v2 type="doughnut" 
                [colors]="this.ondeForamFeitos.colors" 
                [data]="this.ondeForamFeitos.data" 
                [labels]="this.ondeForamFeitos.labels"></split-doughnut-v2>
              </div>
            </div>
        </div>          
    </div>  
    <div class="grid mt-2">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div>
              <span class="title"> Cancelamentos e Faltas </span> <br />
              <span class="subtitle">Certifique-se sempre de atualizar o status "cancelado" para obter 
                resultados mais precisos
              </span>
            </div>
          </div>
          <div class="card-message mt-5 mb-5" style="background-color:#f4f7fc">
            <span>02%</span>
            <span>Faltas</span>
            <span pRipple>Ver relatório</span>
          </div>   
          <div class="card-message mt-5 mb-5" style="border-color:#db0000b9;background-color:#fcebeb">
            <span style="color:#db0000b9">42%</span>
            <span>Cancelamentos feitos por você</span>
            <span style="color:#db0000b9" pRipple>Ver relatório</span>
          </div>
          <div class="card-message mt-5 mb-5" style="border-color:#FF8321;background-color:#fff5ed">
            <span style="color:#FF8321">56%</span>
            <span>Cancelametos feitos pelos pacientes</span>
            <span pRipple style="color:#FF8321">Ver relatório</span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div>
              <span class="title"> Mensagens enviadas sobre os agendamentos </span> <br />
              <span class="subtitle">Para prevenir faltas e garantir o acompanhamento após a consulta</span>
            </div>
          </div>   
          <div class="card-message mt-5 mb-5 flex" style="background-color:#ebf5eb;border-color:#0b83008a">
            <span style="color: #0A8300">282</span>
            <span>
              Total
            </span>
          </div>
          <div class="card-message mt-5 mb-5" style="border-color:#7A95DC;background-color:#f4f7fc">
            <span style="color:#7A95DC">05</span>
            <span>Horas poupadas graças a essa mensagem</span>
          </div>
          <div class="card-message mt-5 mb-5" style="border-color:#FF8321;background-color:#fff5ed">
            <span style="color:#FF8321">28</span>
            <span>Cancelametos feitos pelos pacientes</span>
          </div>
        </div>
      </div>
    </div>   
    <div class="grid mt-2">
      <div class="col md:col-6"> 
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div class="w-full">
              <div class="flex  mb-3 justify-content-between">
                <div>
                  <span class="title"> Agendamentos por serviço ou exame </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card flex justify-content-center">
            <split-doughnut-v2 type="doughnut" style="width: 100%;"
            [colors]="this.agendamentoServicoExame.colors" 
            [data]="this.agendamentoServicoExame.data" 
            [labels]="this.agendamentoServicoExame.labels"></split-doughnut-v2>
          </div>
        </div>
      </div>    
      <div class="col md:col-6"> 
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div class="w-full">
              <div class="flex  mb-3 justify-content-between">
                <div>
                  <span class="title"> Agendamentos por profissional </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card flex justify-content-center">
            <split-doughnut-v2 type="doughnut" 
            [colors]="this.agendamentoProfissional.colors" 
            [data]="this.agendamentoProfissional.data" 
            [labels]="this.agendamentoProfissional.labels"></split-doughnut-v2>
          </div>
        </div>
      </div>     
    </div>        
    <div class="grid mt-2">
      <div class="col md:col-6"> 
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div class="w-full">
              <div class="flex  mb-3 justify-content-between">
                <div>
                  <span class="title"> Agendamentos por serviço ou exame </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card flex justify-content-center">
            <split-doughnut-v2 type="doughnut" style="width: 100%;"
            [colors]="this.agendamentoServicoExame.colors" 
            [data]="this.agendamentoServicoExame.data" 
            [labels]="this.agendamentoServicoExame.labels"></split-doughnut-v2>
          </div>
        </div>
      </div>    
      <div class="col md:col-6"> 
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div class="w-full">
              <div class="flex  mb-3 justify-content-between">
                <div>
                  <span class="title"> Agendamentos por profissional </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card flex justify-content-center">
            <split-doughnut-v2 type="doughnut" 
            [colors]="this.agendamentoProfissional.colors" 
            [data]="this.agendamentoProfissional.data" 
            [labels]="this.agendamentoProfissional.labels"></split-doughnut-v2>
          </div>
        </div>
      </div>     
    </div>          
    <div class="grid mt-2">
      <div class="col"> 
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div class="w-full">
              <div class="flex  mb-3 justify-content-between">
                <div>
                  <span class="title"> Consultas por tipo de cliente </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <split-progress-bar [value]="[52,42,06]" [colors]="['#FF8321','#AD5916','#999999']"></split-progress-bar>
          </div>
          <div class="card-message mt-5 mb-5" style="border-color:#FF8321">
            <span style="color:#FF8321">52%</span>
            <span>Clientes novos</span>
          </div>
          <div class="card-message mt-5 mb-5" style="border-color:#AD5916">
            <span style="color:#AD5916">42%</span>
            <span>Clientes acompanhamento</span>
          </div>
          <div class="card-message mt-5 mb-5" style="border-color:#999999">
            <span style="color:#999999">06%</span>
            <span>Consultas gratuitas</span>
          </div>
        </div>
      </div>    
      <div class="col"> 
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div class="w-full">
              <div class="flex  mb-3 justify-content-between">
                <div>
                  <span class="title"> Distribuição de agendamentos </span>
                </div>
              </div>
            </div>
          </div>
          <div class="card flex justify-content-center">
            <split-doughnut-v2 type="doughnut" 
            [colors]="this.distribuicaoAgendamentos.colors" 
            [data]="this.distribuicaoAgendamentos.data" 
            [labels]="this.distribuicaoAgendamentos.labels"></split-doughnut-v2>
          </div>
        </div>
      </div>     
    </div>           
</section>
